interface FirmContact {
  phone_number?: string | null;
  web_url?: string | null;
}

export const getFirmContactHref = (contact?: FirmContact | null): string | null => {
  const digits = (contact?.phone_number || "").replace(/\D/g, "");
  if (digits) {
    return `tel:${digits}`;
  }
  const url = (contact?.web_url || "").trim();
  if (!url) {
    return null;
  }
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};
